import { FC } from 'react';
import ArraySelect from './ArraySelect';
import { getLang } from '@src/packages/pro-table/component/util';

export interface SingleSelectProps {
  schema: any;
  disabled?: boolean;
  invalid?: boolean;
  value?: any;
  onChange?: (val: any) => void;
  placeholder?: string;
  currentLocale?: string;
  modelSelectField?: string;
}

const SingleSelect: FC<SingleSelectProps> = (props: SingleSelectProps) => {
  const locale = getLang();
  const currentLocale = props.currentLocale || locale.split('-')[0] || 'vi';
  return (
    <ArraySelect
      type='radio'
      {...props}
      currentLocale={currentLocale}
      modelSelectField={props.modelSelectField}
    />
  );
};

export default SingleSelect;
